/// <reference path='references.ts' />
(function($) {

	$.fn.dropdowntree = function(options) {
		// build main options before element iteration
		options = $.extend(true, {}, $.fn.dropdowntree.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
			$this.options = $.metadata ? $.extend(true, {}, options, $this.metadata()) : options;
			$this.options = $.fn.dataset ? $.extend(true, $this.options, $this.dataset()) : $this.options;

			var $dropDownButton = $this;

			var $dropdowntree = $dropDownButton.find('.tree');

			var names = {};
			var idsToNames = {};
			var source = buildSource($dropdowntree.children('ul'));
			$dropdowntree.children('ul').remove();
			names = Object.keys(names);

			// Recursively build the source object from the metadata on the ul
			function buildSource($ul) {
				var items = [];
				$ul.children('li').each(function(){
					var $li = $(this);
					var item = $li.data('item');
					names[item.name] = true;
					idsToNames[item.id] = item.name;
					if ($li.children('ul').length > 0) {
						item.items = buildSource($li.children('ul'));
					}
					items.push(item);
				});
				return items;
			}

			var width = DropdownUtil.calculateWidth($this, '.dropdowntree');

			var buttonProperties = {
				theme: 'trackit',
				width: width,
				height: 15,
				disabled: $this.is('.disabled')
			};

			var treeProperties = {
				source: source,
				width: width,
				theme: 'trackit',
				checkboxes: true,
				hasThreeStates: !$this.is('.two-states')
			};


			$dropDownButton.jqxDropDownButton(buttonProperties);

			$dropdowntree.jqxTree(treeProperties);

			var treeHeight = $dropdowntree.height();
			if (treeHeight > 360) {
				$dropdowntree.jqxTree({height:360});
			}

			// Sync the button text with the checked items
			updateDropDownButtonContent();
			$dropdowntree.on('checkChange', function() {
				if ($this.is('.bracket-children')) {
					updateDropDownButtonContentBracketChildren();
				} else {
					updateDropDownButtonContent();
				}
			});

			function updateDropDownButtonContentBracketChildren() {
				var result = '';
				var items = $dropdowntree.jqxTree('getItems');
				if (items.length > 0) {
					// Map from parent ID to child labels
					var parentCheckedChildMap = new Map();
					var parentChildCountMap = new Map();
					var parentIdToLabelMap = new Map();
					var currentParentId;
					for (var i = 0; i < items.length; i++) {
						var item = items[i];
						if (item.label === selectAllText) {
							continue;
						}
						else if (item.parentId === null) {
							parentCheckedChildMap.set(item.id, new Array());
							parentIdToLabelMap.set(item.id, item.label);
							parentChildCountMap.set(item.id, 0);
							currentParentId = item.id;
						}
						else {
							if (item.checked || item.checked === null) {
								parentCheckedChildMap.get(currentParentId).push(item.label);
							}
							var count = parentChildCountMap.get(currentParentId);
							parentChildCountMap.set(currentParentId, count + 1);
						}
					}

					parentCheckedChildMap.forEach(function (value, key, map) {
						var children = value;
						if (children.length != 0) {
							if (result.length > 0) {
								result += ", ";
							}
							result += parentIdToLabelMap.get(key);
							if (children.length < parentChildCountMap.get(key)) {
								result += ' (';
								var childrenStr = '';
								for (var i = 0; i < children.length; i++) {
									if (childrenStr.length > 0) {
										childrenStr += ", ";
									}
									childrenStr += children[i];
								}

								result += childrenStr + ')';
							}
						}
					});
				}
				if(result.length == 0) {
					result = $dropDownButton.data('placeholder');
					$dropDownButton.css("color", "#999");
				} else {
					$dropDownButton.css("color", "");
				}
				var $content = $('<div>'+result+'</div>');
				$content.css("max-width", width - 30);
				$content.css("overflow", "hidden");
				$content.css("display", "block");
				$content.css("width", width - 30);
				$content.css("text-overflow", "ellipsis");
				$content.css("padding-bottom", 1);
				$dropDownButton.jqxDropDownButton('setContent', $content);
			}

			function updateDropDownButtonContent() {
				var result = '';
				var items = $dropdowntree.jqxTree('getItems');
				if (items.length > 0) {
					for (var i = 0; i < items.length; i++) {
						var item = items[i];
						if ((item.checked || item.checked === null) && item.label != selectAllText) {
							if (result.length > 0) {
								result += ', ';
							}
							result += item.label;
						}
					}
				}
				if(result.length == 0) {
					result = $dropDownButton.data('placeholder');
				}
				var $content = $('<div>'+result+'</div>');
				$content.css("max-width", width - 30);
				$content.css("overflow", "hidden");
				$content.css("display", "block");
				$content.css("width", width - 30);
				$content.css("text-overflow", "ellipsis");
				$content.css("padding-bottom", 1);
				$dropDownButton.jqxDropDownButton('setContent', $content);
			}

			// Create hidden inputs and sync with the checked items
			var $hiddenInputs = {};
			for (var i = 0; i < names.length; i++) {
				var name = names[i];
				$hiddenInputs[name] = $('<input type="hidden" name="'+escape(name)+'" />');
				$dropDownButton.append($hiddenInputs[name]);
			}
			updateHiddenInputs();
			$dropdowntree.on('checkChange', function () {
				updateHiddenInputs();
			});

			function updateHiddenInputs() {
				var vals = {};
				var items = $dropdowntree.jqxTree('getItems');
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					// checked is null for indeterminate
					if (item.checked || item.checked === null) {
						var name = idsToNames[item.id];
						var val = vals[name] || '';
						if (val && val.length > 0) {
							val += ',';
						}
						val += item.value;
						vals[name] = val;
					}
				}
				for (var j = 0; j < names.length;j++) {
					$hiddenInputs[names[j]].val(vals[names[j]] || '');
				}
			}

			var isSelect = true;
			// Sync the select state with the check state
			$dropdowntree.on('select', function (event) {
				var args = event.args;
				var element = args.element;
				var item = $dropdowntree.jqxTree('getItem', element);
				if (isSelect) {
					$dropdowntree.jqxTree('checkItem', element, !item.checked);
				}
				// clear selection (otherwise item remains selected)
				$dropdowntree.jqxTree('clearSelection');
				// clearing the selection seems to cause a double event so use a boolean field to only process every other event
				isSelect = !isSelect || item.label == selectAllText;
			});

			// Expand and collapse sub-trees according to selection
			$dropdowntree.on('checkChange', function (event) {
				if(event.args.checked) {
					$dropdowntree.jqxTree('expandItem', event.args.element);
				}
				else {
					// When in two state mode and deselecting single item, keep tree expanded as children may be checked
					if ($this.is('.two-states') && ctrlPressed) {
						return;
					}
					var item = $dropdowntree.jqxTree('getItem', event.args.element);
					if(item && item.hasItems && item.checked == false) {
						$dropdowntree.jqxTree('collapseItem', event.args.element);
					}
				}
			});

			// Create a Select All item
			var selectAllText = translate('(Select All)');
			$dropdowntree.jqxTree('addBefore', { label: selectAllText }, $dropdowntree.jqxTree('getItems')[0].element);

			// handle select all item.
			var handleCheckChange = true;
			updateSelectAll();
			$dropdowntree.on('checkChange', function (event) {
				updateSelectAll(event);
			});

			function updateSelectAll(event) {
				if (!handleCheckChange)
					return;

				var firstItem = $dropdowntree.jqxTree('getItems')[0];
				var checkedItems = $dropdowntree.jqxTree('getCheckedItems').slice();
				var items = $dropdowntree.jqxTree('getItems').slice();
				if (checkedItems.indexOf(firstItem) > -1) {
					checkedItems.splice(checkedItems.indexOf(firstItem), 1);
				}
				items.splice(items.indexOf(firstItem), 1);
				if (!event || event.args.element != firstItem.element) {
					//noinspection JSUnusedAssignment
					handleCheckChange = false;

					if (checkedItems.length == 0) {
						$dropdowntree.jqxTree('uncheckItem', firstItem.element);
					}
					else if (checkedItems.length < items.length) {
						$dropdowntree.jqxTree('uncheckItem', firstItem.element);
						$dropdowntree.jqxTree('checkItem', firstItem.element, null);
					}
					else {
						$dropdowntree.jqxTree('uncheckItem', firstItem.element);
						$dropdowntree.jqxTree('checkItem', firstItem.element);
					}
					handleCheckChange = true;
				}
				else {
					//noinspection JSUnusedAssignment
					handleCheckChange = false;
					if (checkedItems.length < items.length) {
						$dropdowntree.jqxTree('uncheckItem', firstItem.element);
						$dropdowntree.jqxTree('checkAll');
						$dropdowntree.jqxTree('expandAll');
					}
					else {
						$dropdowntree.jqxTree('uncheckAll');
						$dropdowntree.jqxTree('collapseAll');
					}
					handleCheckChange = true;
				}
			}

            // Add class to drop down when default option is selected
			updateDefaultOptionClass();
			$dropdowntree.on('checkChange', function (event)
			{
				if (event.args) {
					updateDefaultOptionClass();
				}
			});

			function updateDefaultOptionClass() {
				if($dropdowntree.jqxTree('getCheckedItems').length == 0) {
					$dropDownButton.addClass('default-option');
				}
				else {
					$dropDownButton.removeClass('default-option');
				}
			}

			// Fix bug where the indeterminate state is not removed from the checkbox
			$dropdowntree.on('checkChange', function (event) {
				var item = $dropdowntree.jqxTree('getItem', event.args.element);
				if(item && item.hasItems && item.checked) {
					var $indeterminate = $(item.checkBoxElement).find('.jqx-checkbox-check-indeterminate');
					if($indeterminate.length > 0) {
						$indeterminate.removeClass('jqx-checkbox-check-indeterminate');
						$indeterminate.removeClass('jqx-checkbox-check-indeterminate-trackit');
					}
				}
			});

			// Fix bug where the expand arrow gets stuck when the item is collapsed
			$dropdowntree.on('collapse',function (event) {
				var item = $dropdowntree.jqxTree('getItem', event.args.element);
				var $expanded = $(item.element).find('.jqx-tree-item-arrow-expand');
				if($expanded.length > 0) {
					$expanded.removeClass('jqx-tree-item-arrow-expand');
					$expanded.removeClass('jqx-tree-item-arrow-expand-trackit');
				}
			});

			// When in 2-state mode, check/uncheck children manually
			var twoStateCheckHandler = function (event) {
				if ($this.is('.two-states') && !ctrlPressed) {
					var children = $(event.args.element).find("li");
					var check = event.args.checked;

					// Disable handler temporarily while check/unchecking children
					$dropdowntree.off('checkChange', twoStateCheckHandler);
					for (var i = 0; i < children.length; i++) {
						$dropdowntree.jqxTree('checkItem', $(event.args.element).find("li")[i], check);
					}
					$dropdowntree.on('checkChange', twoStateCheckHandler);
				}
			};

			$dropdowntree.on('checkChange', twoStateCheckHandler);

			var ctrlPressed = false;
			var handleCtrlpressed = function (e) {
				ctrlPressed = e.ctrlKey;
			};

			// Cannot use 'keypress' event as it does not handle non-printing keys like Ctrl
			$(document).on('keydown', handleCtrlpressed);
			$(document).on('keyup', handleCtrlpressed);
        });
	};

})(jQuery);
